<div class="row pt-5">
    <div class="col d-flex justify-content-center " [ngClass]="{'border-left-thin-gray': icons.indexOf(icon)>0}"
        *ngFor="let icon of icons">
        <app-icon-with-title [glyph]="glyph" [badge]="badge" [scale]="icon.scale" [radio]="radio" [large]="large"
            [border]="border" [complete]="border" [alt]="border" [disabled]="border" [name]="icon.name"
            [title]="icon.title" [link]="icon.link" [internalLink]="icon.internalLink" [target]="icon.target"
            [tooltip]="icon.tooltip">
        </app-icon-with-title>
    </div>
</div>